"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGBarChart = void 0;
const react_1 = __importStar(require("react"));
const bar_1 = require("@nivo/bar");
const lodash_1 = require("lodash");
const common_1 = require("./common");
const configContext_1 = require("../../../contexts/configContext");
const TGBarChart = (props) => {
    // TODO: [S5-3587] Consolidate inline props with `defaultProps` to facilitate options/value property merging with default values.
    const chartProps = (0, react_1.useMemo)(() => (0, common_1.mergeChartProps)(props, SAMPLE_PROPS), [props]);
    const { layout, indexBy, groupMode, legendPosition, colorPalette: colorPaletteName } = chartProps;
    const { colorPalettes, primaryPalette } = (0, configContext_1.useConfig)();
    const colors = (0, react_1.useMemo)(() => { var _a, _b, _c; return (_c = (_b = (_a = colorPalettes === null || colorPalettes === void 0 ? void 0 : colorPalettes.find(x => x.name === colorPaletteName)) === null || _a === void 0 ? void 0 : _a.colors) !== null && _b !== void 0 ? _b : primaryPalette) !== null && _c !== void 0 ? _c : undefined; }, [colorPalettes, colorPaletteName]);
    return (react_1.default.createElement(bar_1.ResponsiveBar, Object.assign({ colors: colors, margin: Object.assign({ top: 50, left: 60 }, (legendPosition === 'bottom' ? {
            right: 50,
            bottom: 80,
        } : {
            right: 130,
            bottom: 50,
        })), padding: 0.3, valueScale: { type: 'linear', nice: true }, indexScale: { type: 'band', round: true }, label: (datum) => datum.value ? `${(0, lodash_1.floor)(datum.value, 2)}` : datum.formattedValue, borderWidth: 0.1, borderColor: {
            from: 'color',
            modifiers: [['darker', 1.6]],
        }, axisTop: null, axisRight: null, axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -20,
            truncateTickAt: 0,
        }, axisLeft: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            truncateTickAt: 0,
        }, labelSkipWidth: 12, labelSkipHeight: 12, labelTextColor: {
            from: 'color',
            modifiers: [['darker', 1.6]],
        }, legends: [
            Object.assign(Object.assign({ dataFrom: 'keys' }, (legendPosition === 'bottom' ? {
                anchor: 'bottom',
                direction: 'row',
                translateX: 0,
                translateY: 56,
            } : {
                anchor: 'bottom-right',
                direction: 'column',
                translateX: 120,
                translateY: 0,
            })), { justify: false, itemsSpacing: 2, itemWidth: 100, itemHeight: 20, itemDirection: 'left-to-right', itemOpacity: 0.85, symbolSize: 20, effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1,
                        },
                    },
                ] }),
        ], ariaLabel: `${groupMode !== null && groupMode !== void 0 ? groupMode : 'stacked'} ${layout !== null && layout !== void 0 ? layout : 'vertical'} bar chart${indexBy ? ` indexed by ${indexBy}` : ''}`, barAriaLabel: (datum) => `${datum.id}: ${datum.formattedValue}${indexBy ? ` in ${indexBy}: ${datum.indexValue}` : ''}` }, chartProps)));
};
exports.TGBarChart = TGBarChart;
const SAMPLE_PROPS = {
    data: [{ "id": "Group A", "Series 1": 123, "Series 2": 176, "Series 3": 32, "Series 4": 67, "Series 5": 200, "Series 6": 167 }, { "id": "Group B", "Series 1": 18, "Series 2": 149, "Series 3": 104, "Series 4": 23, "Series 5": 22, "Series 6": 139 }, { "id": "Group C", "Series 1": 5, "Series 2": 179, "Series 3": 199, "Series 4": 119, "Series 5": 14, "Series 6": 45 }, { "id": "Group D", "Series 1": 129, "Series 2": 197, "Series 3": 139, "Series 4": 171, "Series 5": 180, "Series 6": 54 }, { "id": "Group E", "Series 1": 77, "Series 2": 18, "Series 3": 159, "Series 4": 182, "Series 5": 45, "Series 6": 25 }, { "id": "Group F", "Series 1": 105, "Series 2": 39, "Series 3": 124, "Series 4": 125, "Series 5": 125, "Series 6": 142 }, { "id": "Group G", "Series 1": 17, "Series 2": 45, "Series 3": 116, "Series 4": 164, "Series 5": 177, "Series 6": 2 }],
    indexBy: 'id',
    keys: ['Series 1', 'Series 2', 'Series 3', 'Series 4', 'Series 5', 'Series 6'],
};
exports.default = exports.TGBarChart;
//# sourceMappingURL=TGBarChart.js.map